/*
 * @Author: shiguang
 * @Date: 2024-04-11 13:28:57
 * @LastEditors: shiguang
 * @LastEditTime: 2024-04-11 13:29:05
 * @Description: 
 */
export enum SupportCenterbizType{
    B = '2b',
    C = '2c',
}